import { fileUrl } from "../../../../../utils";

type IpropsInvestorIsvHeader = {
  profil: string;
  userName: string;
  showProfil: (userId: string) => void;
  userId: string;
};
export default function CommunityHeader(props: IpropsInvestorIsvHeader) {
  return (
    <>
      <div className="d-flex mr-5">
        <div className="photo-title">
          {props.profil && <img src={fileUrl(props.profil)} alt="profil" />}
        </div>
        <div className="info-title">
          <div className="company-title">
            <a href="javascript:;" className="disable-click-name">
              {props?.userName || "-"}
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
